import fetch from '../../lib/wrappedFetch'
import config from '../../config'

class EventsService {
  searchEvents = (params) => {
    return fetch(config.config.endpointUrls.searchEvents(), {
      method: 'POST',
      body: params
    })
  }
  fetchEventById = (params) => {
    return fetch(config.config.endpointUrls.fetchEventById(params), {
      method: 'GET'
    })
  }
  deleteEventById = (params) => {
    return fetch(config.config.endpointUrls.deleteEventById(params), {
      method: 'DELETE'
    })
  }
  fetchAllEventTags = (params) => {
    return fetch(config.config.endpointUrls.fetchAllEventTags(params), {
      method: 'GET'
    })
  }
}

export default new EventsService()



// WEBPACK FOOTER //
// ../src/services/eventsService/eventsService.js